/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckDocumentMrzConfiguration {
    NONE = 'NONE',
    DATA_PAGE = 'DATA_PAGE',
    CARD_FRONT = 'CARD_FRONT',
    CARD_BACK = 'CARD_BACK'
}


export function instanceOfPaxCheckDocumentMrzConfiguration(value: any): boolean {
    for (const key in PaxCheckDocumentMrzConfiguration) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckDocumentMrzConfiguration, key)) {
            if (PaxCheckDocumentMrzConfiguration[key as keyof typeof PaxCheckDocumentMrzConfiguration] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckDocumentMrzConfigurationFromJSON(json: any): PaxCheckDocumentMrzConfiguration {
    return PaxCheckDocumentMrzConfigurationFromJSONTyped(json, false);
}

export function PaxCheckDocumentMrzConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckDocumentMrzConfiguration {
    return json as PaxCheckDocumentMrzConfiguration;
}

export function PaxCheckDocumentMrzConfigurationToJSON(value?: PaxCheckDocumentMrzConfiguration | null): any {
    return value as any;
}

export function PaxCheckDocumentMrzConfigurationToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckDocumentMrzConfiguration {
    return value as PaxCheckDocumentMrzConfiguration;
}

